import { render } from "./AdministerCollectionItem.vue?vue&type=template&id=f8a7ff84"
import script from "./AdministerCollectionItem.vue?vue&type=script&lang=js"
export * from "./AdministerCollectionItem.vue?vue&type=script&lang=js"

import "./AdministerCollectionItem.vue?vue&type=style&index=0&id=f8a7ff84&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__